import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/pages/ErrorPage.css';

const ErrorPage = ({ message }) => {
  return (
    <Container className="error-container">
      <Helmet>
        <title>Error - WeiFinders</title>
        <meta name="description" content="An error occurred on WeiFinders. Please try again or return to the home page." />
        <meta name="robots" content="noindex" />
        <meta property="og:title" content="Error - WeiFinders" />
        <meta property="og:description" content="An error occurred on WeiFinders. Please try again or return to the home page." />
        <link rel="canonical" href="https://weifinders.com/error" />
      </Helmet>
      <main role="main">
        <Card className="error-card">
          <Card.Body>
            <header>
              <h2 className="error-title">Error</h2>
            </header>
            <p className="error-message" role="alert">{message}</p>
            <Button as={Link} to="/" variant="primary" className="home-button" aria-label="Home">
              Home
            </Button>
          </Card.Body>
        </Card>
      </main>
    </Container>
  );
};

export default ErrorPage;
